import { render, staticRenderFns } from "./MarketApproveRenewContract.vue?vue&type=template&id=d1e096a0"
import script from "./MarketApproveRenewContract.vue?vue&type=script&lang=js"
export * from "./MarketApproveRenewContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports